import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { findRecord } from '@warp-drive/utilities/json-api';
import type RouterService from '@ember/routing/router-service';
import type { Store as StoreService } from '@warp-drive/core';
import type { ObservableDocumentExtension as ObservableDocumentModel } from 'tio-data/data/resources/observable-document.ext';

type RouteParams = {
  observable_document_id: string;
};

export default class AuthenticatedObservabilityConfirmRoute extends Route {
  @service declare store: StoreService;
  @service declare router: RouterService;

  async model(params: RouteParams) {
    const id = params['observable_document_id'];

    const { content } = (await this.store.request(
      findRecord<ObservableDocumentModel>('observable-document', id, {
        include:
          'observable-asset,financial-institution,account-transactions,person.employees.plan',
      })
    )) as { content: { data: ObservableDocumentModel } };

    return content.data;
  }

  async afterModel(model: ObservableDocumentModel) {
    if (model.subsistenceState !== 'SubsistenceState.IMPLICIT') {
      this.router.transitionTo(
        'authenticated.observability.documents.show',
        // @ts-expect-error this seems like a bug
        model.observableDocument
      );
    }
  }
}
